<template>
  <section>
    <footer>
      <p>Copyright © 2024 Climacool srl. Tutti i diritti riservati.</p>
    </footer>
  </section>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

section {
  padding: 0;

  footer {
    padding: 1.2em 0;
    background-color: #141318;
    p {
      color: white;
      text-align: center;
      margin-bottom: 0;
      font-size: 0.8rem;
    }
  }
}
</style>
